import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { contactPersonRole, getFullName } from '../Person/utils';
import { getAmenityReservationTime } from './utils';

const getTableData = (data, columns) => {
  const headers = columns
    .filter(({ id }) => id !== 'actions')
    .map(({ Header }) => Header);

  const rows = [];

  data.forEach(
    ({
      amenity,
      date,
      startTime,
      endTime,
      contactPerson: reservedBy,
      comments,
      status,
    }) => {
      const building = amenity?.building?.name;
      const name = amenity?.name;
      const { displayDate } = getAmenityReservationTime(
        date?.slice(0, -6),
        startTime,
        endTime,
        amenity,
      );
      const contactPerson = getFullName(reservedBy);
      const role = contactPersonRole(reservedBy);

      // TODO: move it to a separate function and check every row and cell

      // @react-pdf/renderer is very sensitive to the content overflow
      // see https://github.com/diegomura/react-pdf/issues/314
      // and https://github.com/diegomura/react-pdf/issues/416
      // and https://github.com/diegomura/react-pdf/issues/836
      //
      // as a result an app will crash if the cell height is greater than
      // available space for it on a page
      //
      // the workaround is the following:
      // 1. all line breaks and carriage returns should be removed
      // 2. long comments should be splitted info multiple strings
      // 3. new rows should be created for the comment's chunks

      // const onePageLimit = 1024;
      // // #1
      // const commentWithNoLineBreaks = fullComment?.replace(/[\r\n]{1,}/g, ' ');
      // const comment = commentWithNoLineBreaks?.substring(0, onePageLimit);
      // const restComment = [];
      // // #2
      // if (commentWithNoLineBreaks?.length > onePageLimit) {
      //   for (
      //     let i = onePageLimit;
      //     i < commentWithNoLineBreaks.length;
      //     i += onePageLimit
      //   ) {
      //     restComment.push(
      //       commentWithNoLineBreaks.substring(i, i + onePageLimit),
      //     );
      //   }
      // }
      rows.push([
        building,
        name,
        displayDate,
        contactPerson,
        role,
        comments,
        status?.status,
      ]);
      // #3
      // if (restComment.length > 0) {
      //   restComment.forEach((commentChunk) =>
      //     rows.push([null, null, null, null, commentChunk]),
      //   );
      // }
    },
  );
  return { headers, rows };
};

const AmenityReservationsExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default AmenityReservationsExport;
